import React from "react";
import { Redirect, Route } from "react-router-dom";

export const RedirectWithTrailingSlash = ({ from, to }) => {
  return (
    <Route
      exact
      path={from}
      render={({ location }) => {
        const { pathname, search } = location;
        if (pathname.endsWith("/") && pathname !== "/") {
          const newPath = pathname.slice(0, -1); // Remove trailing slash
          return <Redirect to={`${newPath}${search}`} />;
        }
        return null;
      }}
    />
  );
};
